/**
 * @fileoverview File upload and drag-and-drop handlers for Chat.
 * @module pages/chat/useChatFileHandlers
 */
import { useCallback } from "react";
import { applyChatFileSelection } from "./chatFileUpload.js";

/** Returns memoized file upload handlers. */
const useChatFileHandlers = (ctx) => {
  const handleAttachFilesClick = useCallback(() => {
    ctx.setShowFileUpload((previous) => !previous);
  }, [ctx.setShowFileUpload]);

  const handleFileUploadClose = useCallback(() => {
    ctx.setShowFileUpload(false);
  }, [ctx.setShowFileUpload]);

  const handleFileClick = useCallback(() => {
    document.getElementById("chat-file-input")?.click();
  }, []);

  const handleFileChange = useCallback(
    (event) => {
      applyChatFileSelection(ctx, event.target.files[0]);
    },
    [ctx],
  );

  const handleDragOver = useCallback(
    (event) => {
      event.preventDefault();
      ctx.setIsDragging(true);
    },
    [ctx.setIsDragging],
  );

  const handleDragLeave = useCallback(
    (event) => {
      event.preventDefault();
      ctx.setIsDragging(false);
    },
    [ctx.setIsDragging],
  );

  const handleDrop = useCallback(
    (event) => {
      event.preventDefault();
      ctx.setIsDragging(false);
      applyChatFileSelection(ctx, event.dataTransfer.files[0]);
    },
    [ctx],
  );

  return {
    handleAttachFilesClick,
    handleFileUploadClose,
    handleFileClick,
    handleFileChange,
    handleDragOver,
    handleDragLeave,
    handleDrop,
  };
};

export default useChatFileHandlers;
